module.exports = __webpack_public_path__ + "img/arrowRight.04e82f76.svg";